<template lang="">
    <div id="content">
      <div class="global_area">
        <div class="path"><a href="#none">Home</a> &gt; <a href="#none">상품 관리</a> &gt; <strong>캠페인 후원자 조회</strong></div>
        <h2 class="h_sub">캠페인 후원자 조회</h2>
      </div>
      
      <CampaignPaymentListForm/>
    </div>
  </template>
  
  <script>
  import CampaignPaymentListForm from '@/components/admin/product/CampaignPaymentListForm.vue';
  
  export default {
    components: {
        CampaignPaymentListForm
    }
  }
  </script>
  <style lang="">
      
  </style>